import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  Alert,
  CircularProgress
} from '@mui/material';
import {
  Medication as MedicationIcon,
  Inventory as InventoryIcon,
  Security as SecurityIcon
} from '@mui/icons-material';
import PharmacyDashboard from '../components/pharmacy/PharmacyDashboard';
import InventoryManagement from '../components/pharmacy/InventoryManagement';
import ControlledMedications from '../components/pharmacy/ControlledMedications';

/**
 * Página principal de Farmacia e Insumos
 * Solo visible para administradores
 * Contiene 3 pestañas: Farmacia, Inventario, Medicamentos Controlados
 */
const PharmacyMain = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <PharmacyDashboard />;
      case 1:
        return <InventoryManagement />;
      case 2:
        return <ControlledMedications />;
      default:
        return <PharmacyDashboard />;
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          <MedicationIcon sx={{ mr: 2, verticalAlign: 'middle' }} />
          Farmacia e Insumos
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Sistema integral de gestión de fármacos, insumos y medicamentos controlados
        </Typography>
      </Box>

      {/* Alerta informativa */}
      <Alert severity="info" sx={{ mb: 3 }}>
        <Typography variant="body2">
          <strong>Módulo de Administración:</strong> Esta sección está restringida a personal administrativo. 
          Gestiona inventario, dispensación y cumplimiento regulatorio de sustancias controladas.
        </Typography>
      </Alert>

      {/* Tabs */}
      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': {
              minHeight: 64,
              fontSize: '0.95rem',
              fontWeight: 500
            }
          }}
        >
          <Tab
            icon={<MedicationIcon sx={{ mr: 1 }} />}
            label="Farmacia"
            iconPosition="start"
          />
          <Tab
            icon={<InventoryIcon sx={{ mr: 1 }} />}
            label="Inventario"
            iconPosition="start"
          />
          <Tab
            icon={<SecurityIcon sx={{ mr: 1 }} />}
            label="Medicamentos Controlados"
            iconPosition="start"
          />
        </Tabs>
      </Paper>

      {/* Tab Content */}
      <Box>
        {renderTabContent()}
      </Box>
    </Box>
  );
};

export default PharmacyMain;
